<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{'CUSTOMER_RECORD_INVITE_TO_HELPDESK' | translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog(false)" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="alert alert-warning" *ngIf="!contactInviteResult">
      <label>{{'CUSTOMER_RECORD_INVITE_TO_HELPDESK_DIALOG_WARNING' | translate: { count: data.customerRecordIds.size } }}</label>
    </div>
    <div *ngIf="contactInviteResult">
      <div class="alert alert-success" *ngIf="contactInviteResult.invited.length > 0">
        <label>{{'CUSTOMER_RECORD_INVITE_TO_HELPDESK_DIALOG_INVITED' | translate}}
          : {{contactInviteResult.invited}}</label>
      </div>
      <div class="alert alert-info" *ngIf="contactInviteResult.alreadyRegistered.length > 0">
        <label>{{'CUSTOMER_RECORD_INVITE_TO_HELPDESK_DIALOG_ALREADY_REGISTERED' | translate}}
          : {{contactInviteResult.alreadyRegistered}}</label>
      </div>
      <div class="alert alert-danger" *ngIf="contactInviteResult.invalidEmail.length > 0">
        <label>{{'CUSTOMER_RECORD_INVITE_TO_HELPDESK_DIALOG_INVALID_EMAIL' | translate}}
          : {{contactInviteResult.invalidEmail}}</label>
      </div>
    </div>
    <mat-dialog-content style="overflow:visible">
      <form (ngSubmit)="submit()" #f="ngForm" id="form"
            [formGroup]="formGroup" novalidate>
        <div class="row form-group"
             *ngIf="!contactInviteResult"
             [ngClass]="{ 'has-danger': hasLocalFieldError('userGroups')}">
          <label
            class="col-form-label form-control-label col-md-4 detail-title"
            [class.required-field-label]="true">{{'COMMON_USER_GROUP' | translate}}</label>

          <div class="col-8">
            <div class="mw-100">
              <angular2-multiselect [data]="userGroups" [settings]="searchableDropdownSettings"
                                    class="form-control"
                                    [(ngModel)]="model._userGroups"
                                    [ngClass]="{ 'form-control-danger': hasLocalFieldError('userGroups') }"
                                    (onRemoteSearch)="onUserGroupSearch($event.target.value)"
                                    name="userGroups"
                                    id="userGroups"
                                    formControlName="userGroups">
              </angular2-multiselect>
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('userGroups')">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-dialog-content>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" *ngIf="!contactInviteResult" (click)="closeDialog(false)">
      {{'COMMON_BUTTON_CANCEL' | translate}}
    </button>
    <button type="submit" class="btn btn-primary" form="form">
      {{(!contactInviteResult ? 'COMMON_BUTTON_OK' : 'COMMON_BUTTON_CONTINUE') | translate}}
    </button>
  </div>
</div>
